import React from "react";

import { Guid } from "../Engine/Types/Guid";
import { useShowOnce } from "../../../Common/UseShowOnce";

import { MINITOUR_CLOSED } from "./metricsAction";

export interface WithShowOnceProps {
    id: string;
    userId?: Guid;
    children?: React.ReactNode;
    openedFrom?: string;
    openFromLink?: boolean;
    minitourEnabled?: boolean;
}

export function withShowOnce<P extends WithShowOnceProps>(
    WrappedComponent: React.ComponentType<P>
): React.ComponentType<P> {
    return function WithShowOnceWrapper(props: P): JSX.Element {
        if (!(props.userId && props.minitourEnabled)) {
            return <WrappedComponent {...props} />;
        }

        const ShowOnceComponent = () => {
            const { isOpen, setIsOpen, addToNidus } = useShowOnce({
                nidusName: "minitour",
                // @ts-expect-error проверка выше гарантирует, что userId определен
                nidusKey: props.userId,
                infoName: props.id,
                onCloseMetricName: MINITOUR_CLOSED,
                openFromMetricName: props.openedFrom ?? props.id,
                openFromLink: props.openFromLink,
            });

            return <WrappedComponent {...props} isOpen={isOpen} setIsOpen={setIsOpen} onClose={addToNidus} />;
        };

        return <ShowOnceComponent />;
    };
}
